<template>
   <div id="app">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
         <a class="navbar-brand" href="#">Dashboard</a>
         <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
         <span class="navbar-toggler-icon"></span>
         </button>
         <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="nav navbar-nav ml-auto">
               <li class="nav-item">
                  <router-link class="nav-link" to="/">To-do</router-link>
               </li>
               <li class="nav-item">
                  <router-link class="nav-link" to="/about/User">About</router-link>
               </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/Calculator">Calculator</router-link>
               </li>
                 <li class="nav-item">
                  <router-link class="nav-link" to="/Notes">Notes</router-link>
               </li>

            </ul>
         </div>
      </nav>
      <router-view/> 
   </div>
   
</template>

<script>
   import Skills from './components/Skills.vue'
   
   export default {
     name: 'app',
     components: {
       Skills
     } 
   }
</script>
<style scoped>
   @import url('https://fonts.googleapis.com/css?family=Montserrat:400,700');
   @import url('https://fonts.googleapis.com/css?family=Yantramanav:100');
   body {
   background-color: #EEEEEE;
   font-family: 'Montserrat', sans-serif;
   display: grid;
   grid-template-rows: auto;
   justify-items: center;
   padding-top: 50px;
   }
   body, html {
   margin: 0;
   height: 100%;
   }
   h1{
   padding-left: 30%;  
   margin-top: auto;
   font-family: 'Yantramanav', sans-serif;
   font-size: 100%;
   font-weight: 2  00;
   color: #e1efe9;
   text-align: center;
   }
   #app {
   width: 50%;
   }
   /* nav {
   padding: 20px 20px 20px 0;
   }
   nav a {
   padding: 10px;
   text-decoration: none;
   background: #fff;
   border-radius: 3px;
   color: rgb(0, 110, 255);
   font-weight: bold;
   margin-right: 15px;
   } */
</style>


// WEBPACK FOOTER //
// src/App.vue